module.exports = __webpack_public_path__ + "img/mission-icon-2.387b4d34.png";